import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "spinner d-flex justify-content-center h-50" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["spinner-border", { 'spinner-border-sm': _ctx.small }]),
      role: "status"
    }, [..._hoisted_3], 2 /* CLASS */)
  ]))
}